import { useLocation, Link } from 'react-router-dom';
import { Square, Waves } from 'lucide-react';
import { Slider } from '@/components/ui/slider';
import { useDrone } from '@/hooks/useDrone';

// Drone pill inside the bottom sounds bar.
export const MiniDroneBar = () => {
  const drone = useDrone();
  const { pathname } = useLocation();
  if (!drone.active || pathname === '/bordone') return null;
  const { cfg, update, toggle } = drone;
  return (
    <div data-testid="mini-drone-bar" className="shrink-0 rounded-full border border-sky-400/40 bg-[#0A0A0A]/95 backdrop-blur-xl shadow-[0_0_24px_rgba(56,189,248,0.2)] pl-1 sm:pl-2 pr-1.5 py-1.5 flex items-center gap-1 sm:gap-2">
      <Link to="/bordone" data-testid="mini-drone-open" aria-label="Apri Bordone" className="h-8 px-2 rounded-full flex items-center gap-1.5 text-sky-300 hover:bg-white/5 min-w-0">
        <Waves className="w-4 h-4 shrink-0" />
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] text-white/50">Bordone</span>
        <span data-testid="mini-drone-note" className="font-mono font-bold text-base leading-none text-white truncate">{drone.label}</span>
        {drone.progOn && <span data-testid="mini-drone-prog" className="hidden sm:inline text-[9px] uppercase tracking-[0.15em] text-sky-300/70">a tempo</span>}
      </Link>
      <Slider data-testid="mini-drone-volume" value={[cfg.volume * 100]} min={0} max={100} step={1} onValueChange={(v) => update({ volume: v[0] / 100 })} className="hidden sm:flex w-28" />
      <button data-testid="mini-drone-stop" aria-label="Ferma bordone" onClick={toggle} className="h-8 w-8 shrink-0 rounded-full bg-sky-400 text-black flex items-center justify-center active:scale-95 transition-transform">
        <Square className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
